import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Picture from '../Picture';

import ICropper from '../../interfaces/ICropper';

import './PartnersList.sass';

interface Props {
  partnersList: IPartnerSection;
  title?:string;
}

interface IPartnerSection {
  title: string;
  _id: string;
  _umbDocumentParents: {
    items: IPartner[];
  };
}

interface IPartner {
  partnerSiteUrl: string;
  picture: ICropper;
  _name: string;
  _createDate: string;
  _id: string;
  section?: string;
}

type FilterList = { [key: string]: any };

function PartnersList({ partnersList, title }: Props) {

  const { items } = partnersList?._umbDocumentParents || {};
  const nonEmptyPartnersSection = items?.filter((partner: IPartner) => Object.keys(partner).length) || [partnersList];

  return (
    <div className="partners">
      <Container>
        {nonEmptyPartnersSection?.length > 0 &&
          (partnersList?.title || title) && (
            <Row>
              <Col xs={12} className="partners__heading">
                <h2 className="uikit-label-small-caps">{partnersList.title || title}</h2>
              </Col>
            </Row>
          )}

        <Row>
          <Col xs={12} className="partners__list">
            {nonEmptyPartnersSection?.map((partner: IPartner) => (
                <a
                  href={buildSocialUrl(partner.partnerSiteUrl)}
                  key={partner._createDate}
                  target="_blank"
                  rel="noreferrer"
                  className="partners__item"
                >
                  {partner.picture && <Picture imageObj={partner.picture}/>}
                </a>
              )
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PartnersList;

function buildSocialUrl(url: string | undefined): string | undefined {
  const httpStr = 'https://';
  if (url) {
    return !url.includes('https://') ? `${httpStr}${url}` : url;
  }

  return undefined;
}
